export enum InstitutionSettingsEnum {
	APPOINTMENT = 'termineinstellungen',
	TEXT_TEMPLATE = 'textvorlagen',
	GDPR = 'dsgvo'
}
